import React from "react";
import { BookOpen, FileText } from "lucide-react";

const formatTime = (seconds) => {
  if (!seconds) return "0 min";
  const minutes = Math.floor(seconds / 60);
  return minutes < 60 ? `${minutes} min` : `${Math.floor(minutes / 60)}h ${minutes % 60}min`;
};

export default function ScormContentProgressPanel({ contents, selectedContentId, onSelectContent }) {
  if (!contents?.length) {
    return <div className="scorm-report-empty">Ce module ne contient aucun contenu SCORM.</div>;
  }

  return (
    <aside className="scorm-content-panel">
      <div className="scorm-panel-title">
        <BookOpen size={17} />
        <span>Contenus SCORM</span>
      </div>
      {contents.map((content) => (
        <button
          className={`scorm-content-card ${selectedContentId === content.contentId ? "active" : ""}`}
          type="button"
          key={content.contentId}
          onClick={() => onSelectContent(content.contentId)}
        >
          <div>
            <strong>{content.contentTitle}</strong>
            <span>{content.learnerCount || 0} apprenants</span>
          </div>
          <div className="scorm-content-stats">
            <span>{content.inProgressCount || 0} en cours</span>
            <span>{(content.completedCount || 0) + (content.passedCount || 0)} terminés</span>
            <span>{formatTime(content.averageTimeSeconds)}</span>
            <span>{content.interactionCount || 0} interactions</span>
            <span>{content.objectiveCount || 0} objectifs</span>
          </div>
          <div className="scorm-sco-mini-list">
            {(content.scos || []).slice(0, 4).map((sco) => (
              <span key={sco.scoId}>
                <FileText size={12} />
                {sco.title}
              </span>
            ))}
          </div>
        </button>
      ))}
    </aside>
  );
}
